export default __webpack_public_path__ + "static/media/iab-revenue.10b46d96.svg";